import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class AnaliseDescontoConclusaoNegativaCampoPersonalizadoSelecionadoService {

  constructor(private http: HttpClient) { }

  salvar(campos, idAnaliseDesconto) {
    const body = {
      campos: campos,
      idAnaliseDesconto: idAnaliseDesconto
    };

    return this.http.post(globals.apiUrl + '/api/AnaliseDescontoConclusaoNegativaCampoPersonalizadoSelecionado/Salvar', body);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/AnaliseDescontoConclusaoNegativaCampoPersonalizadoSelecionado/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  montarParaCadastrar(idAnaliseDesconto) {
    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDescontoConclusaoNegativaCampoPersonalizadoSelecionado/MontarParaCadastrar',
      { params: new HttpParams().set('idAnaliseDesconto', idAnaliseDesconto) });
  }
}
